import { requests } from '../apiAgent';

export const PreliquidationDaySummariesBonusRulesAPI = {
    create: ({
        bonusRuleIds,
        startDate,
        endDate,
        employeeIds,
    }: {
        bonusRuleIds: number[];
        startDate: string;
        endDate: string;
        employeeIds: (number | string)[];
    }) => {
        return requests
            .post('/dublin/api/v2/preliquidation-day-summaries-bonus-rules', {
                bonusRuleIds,
                startDate,
                endDate,
                employeeIds,
            })
            .then((response) => response);
    },
};